export default __webpack_public_path__ + "static/media/arrowLeftWhite.a03c6112.svg";